import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {
   SingleCourseService,
   ListResourcesCourses,
   ListThemaryCourses,
   getTestimonialsService,
   DeleteTestimonialService,
   getTestimonialsCourse,
} from "../services/CoursesServices";
import {FacilitatorsCourseService} from "../services/FacilitatorsService";
import {UpdateSubthemeCourse} from "../services/GeneralServices";

export const EditCourseContext = React.createContext();

const selectBackColor = (type) => {
   type = Number(type);
   switch (type) {
      case 1:
         return "#af0069";
      case 2:
         return "#8e44ad";
      case 3:
         return "#2980b9";
      case 5:
         return "#8e44ad";
      default:
         return "#32529d";
   }
};

export default function EditCourseProvider({children, theme}) {
   const [currentTheme, setTheme] = useState();
   const [isSaving, setSaving] = useState(false);
   const [updatingData, setUpdating] = useState(false);

   const [defaultData, setDefaultData] = useState({});
   const [isLoadingData, setLoading] = useState(true);
   // media data
   const [mediaCourse, setMediaCourse] = useState({isLoading: true, data: []});
   const [docsCourse, setDocsCourse] = useState({isLoading: true, data: []});
   // emario
   const [currentThemary, setCurrentThemary] = useState({isLoading: true, data: []});
   // facilitatores
   const [currentFacilitators, setCurrentFacilitators] = useState({isLoading: true, data: []});
   // testimonios
   const [testimonialsList, setTestimonials] = useState({isLoading: true, data: []});
   // testimonios
   const [testimonialsCourse, setTestimonialsCourse] = useState({isLoading: true, data: []});

   let {id, type} = useParams();

   useEffect(() => {
      getInitialData();
   }, [id]);

   useEffect(() => {
      setTheme({...theme, back: selectBackColor(type)});
   }, [type]);

   const getInitialData = () => {
      SingleCourseService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setDefaultData(data[0]);
         })
         .then(() => {
            setLoading(false);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   const getMediaData = (force = false) => {
      let dataChanged = mediaCourse.data.length > 0 && docsCourse.data.length > 0;
      if (dataChanged && !force) return false;
      ListResourcesCourses(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let pdfFile = data.filter((doc) => doc.resourceType === "pdf");
            // console.log(pdfFile);
            setDocsCourse({isLoading: false, data: [...pdfFile]});
            let videoFiles = data.filter((doc) => doc.resourceType === "video");
            // console.log(videoFiles);
            setMediaCourse({isLoading: false, data: [...videoFiles]});
         })
         .catch((e) => {
            console.log(e);
            setDocsCourse({isLoading: false, data: []});
            setMediaCourse({isLoading: false, data: []});
         });
   };

   const deleteDoc = (id) => {
      let pdfFile = docsCourse.data.filter((docu) => docu.idResource !== id);
      setDocsCourse({isLoading: false, data: [...pdfFile]});
   };

   const getThemary = () => {
      ListThemaryCourses(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setCurrentThemary({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setCurrentThemary({isLoading: false, data: []});
            console.log(e);
         });
   };

   const getCurrentFacilitators = () => {
      FacilitatorsCourseService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            // console.log(data);
            let newCurrent = data.map((item) => item.idFacilitator);
            setCurrentFacilitators({isLoading: false, data: [...newCurrent]});
         })
         .catch((e) => {
            console.log(e);
            setCurrentFacilitators({isLoading: false, data: []});
         });
   };

   const updateSubclass = (dat) => {
      let fater = currentThemary.data.find((themary) => themary.idTemaryClasses === dat.idTemaryClasses);
      let onBaseClass = fater.data.find((bClas) => bClas.idTemarySubclasses === dat.idTemarySubclasses);
      if (onBaseClass.name !== dat.name) {
         UpdateSubthemeCourse(dat)
            .then((res) => res.json())
            .then((resp) => {
               const {status, data} = resp;
               if (status === "error") throw new Error();
               // console.log(resp);
            })
            .catch((e) => {
               console.log(e);
            });
      }
   };

   const getTestimonials = (force = false) => {
      if (testimonialsList.data.length > 0 && !force) return false;
      getTestimonialsService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(resp);
            setTestimonials({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setTestimonials({isLoading: false, data: []});
            console.log(e);
         });
   };

   const getTestimonialsByCourse = (force = false) => {
      if (testimonialsCourse.data.length > 0 && !force) return false;
      getTestimonialsCourse(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            console.log(resp);
            setTestimonialsCourse({isLoading: false, data: [...data]});
         })
         .catch((e) => {
            setTestimonialsCourse({isLoading: false, data: []});
            console.log(e);
         });
   };

   const deleteTest = (id) => {
      setUpdating(true);

      let newTest = testimonialsCourse.data.filter((testa) => testa.idTestimonial !== id);

      DeleteTestimonialService(id)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            setTestimonialsCourse({isLoading: false, data: [...newTest]});
         })
         .then(() => {
            setUpdating(false);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   return (
      <EditCourseContext.Provider
         value={{
            isSaving,
            setSaving,
            isLoadingData,
            defaultData,
            currentTheme,
            getMediaData,
            mediaCourse,
            docsCourse,
            getThemary,
            currentThemary,
            // faclitadores
            currentFacilitators,
            getCurrentFacilitators,
            // eliminar pdf
            deleteDoc,
            // actualizar solo las clases que cambiaon
            updateSubclass,
            // testimonials
            getTestimonials,
            testimonialsList,
            deleteTest,
            updatingData,
            getTestimonialsByCourse,
            testimonialsCourse,
         }}
      >
         {children}
      </EditCourseContext.Provider>
   );
}
